"use client";
import { useState } from "react";

export const BuyExampleImageToggle = () => {
  const [isOpen, setIsOpen] = useState(false);

  if (isOpen) {
    return (
      <img
        className="w-full max-h-[512px] block object-contain"
        src="/buy-credits-example-screenshot.png"
        alt="Skjermdump av siden for kjøp av kreditter."
      />
    );
  } else {
    return (
      <span>
        <button onClick={() => setIsOpen(true)} className="underline">
          Se eksempel på kjøpsskjerm
        </button>
      </span>
    );
  }
};
